import { makeProject } from "@revideo/core";
import { HEIGHT, WIDTH } from "@hudhud/reel/math";
import { reelScene } from "./reel";

/** The Revideo project the renderer opens: one scene, the reel, at the reel's size. The clip arrives as the `props` variable. */
export default makeProject({ scenes: [reelScene], settings: { shared: { size: { x: WIDTH, y: HEIGHT } } } });
